
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","viewBox":"0 0 68.1 68.1","preserveAspectRatio":"xMidYMin meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.4 41.3c0 1.1-.9 2.1-2.1 2.1H26.8c-1.1 0-2.1-.9-2.1-2.1V26.8c0-1.1.9-2.1 2.1-2.1h14.4c1.1 0 2.1.9 2.1 2.1v14.5zm12.3 10.8c0 2-1.6 3.6-3.6 3.6H16c-2 0-3.6-1.6-3.6-3.6V16c0-2 1.6-3.6 3.6-3.6h36.1c2 0 3.6 1.6 3.6 3.6v36.1zM56.8 0H11.4C5.1 0 0 5.1 0 11.4v45.4C0 63 5.1 68.1 11.4 68.1h45.4c6.2 0 11.4-5.1 11.4-11.4V11.4C68.1 5.1 63 0 56.8 0"}})])
          )
        }
      }
    